<template>
  <page-header-wrapper>
    <a-card title="注册页视频配置" :bordered="false" :loading="loading">
      <a-alert
        type="info"
        show-icon
        style="margin-bottom:24px"
        message="用于商城注册 / 登录入口的背景视频。国内版和国际版分别配置，留空则使用 APP 内置视频（res/raw/loginbg.mp4）。请上传竖屏 MP4 / WebM，最大 50MB，背景静音循环播放。"
      />
      <a-row :gutter="32">
        <a-col v-for="item in regions" :key="item.key" :md="12" :xs="24">
          <h3>{{ item.label }}</h3>
          <file-upload
            :value="form[item.key]"
            type="video"
            :count="1"
            accept="video/mp4,video/webm,.mp4,.webm"
            @change="v => $set(form, item.key, v)"
          />
          <video
            v-if="form[item.key]"
            :src="form[item.key]"
            controls
            muted
            preload="metadata"
            class="video"
          />
          <p v-else class="hint">当前使用 APP 内置视频</p>
        </a-col>
      </a-row>
      <a-button
        v-hasPermi="['dkmall:registration:edit']"
        type="primary"
        :loading="saving"
        @click="save"
      >保存配置</a-button>
    </a-card>
  </page-header-wrapper>
</template>
<script>
import request from '@/utils/request'
import FileUpload from '@/components/FileUpload'
export default {
  name: 'DkRegistrationPage',
  components: { FileUpload },
  data() {
    return {
      loading: false,
      saving: false,
      form: { videoCn: '', videoEn: '' },
      regions: [
        { key: 'videoCn', label: '国内版注册页视频' },
        { key: 'videoEn', label: '国际版注册页视频' }
      ]
    }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      return request({ url: '/dkmall/registration-page' })
        .then(r => { this.form = r.data || { videoCn: '', videoEn: '' } })
        .finally(() => { this.loading = false })
    },
    save() {
      this.saving = true
      return request({ url: '/dkmall/registration-page', method: 'put', data: this.form })
        .then(() => this.$message.success('注册页视频配置已保存'))
        .finally(() => { this.saving = false })
    }
  }
}
</script>
<style scoped>
.video { width: 100%; max-height: 420px; background: #111; margin: 16px 0; object-fit: contain; }
.hint { color: #888; margin: 24px 0; }
</style>
